var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10C8.68629 10 6 12.6863 6 16V32C6 35.3137 8.68629 38 12 38H36C39.3137 38 42 35.3137 42 32V16C42 12.6863 39.3137 10 36 10H12ZM2 16C2 10.4772 6.47715 6 12 6H36C41.5228 6 46 10.4772 46 16V32C46 37.5228 41.5228 42 36 42H12C6.47715 42 2 37.5228 2 32V16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0146 16.2596C19.6416 15.9046 20.4111 15.9143 21.029 16.285L31.029 22.285C31.6314 22.6465 32 23.2975 32 24C32 24.7025 31.6314 25.3535 31.029 25.715L21.029 31.715C20.4111 32.0857 19.6416 32.0954 19.0146 31.7404C18.3876 31.3854 18 30.7205 18 30V18C18 17.2795 18.3876 16.6146 19.0146 16.2596ZM22 21.5324V26.4676L26.1127 24L22 21.5324Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.1f8679e6506a7edb48ad7cb9aa343f7f.svg";
export { ForwardRef as ReactComponent };